/* Hadara Theme JS */
(function () {
  'use strict';

  // ---------- MOBILE NAV ----------
  const navToggle = document.querySelector('.nav-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  if (navToggle && mobileNav) {
    const panel = mobileNav.querySelector('.mobile-nav__panel');

    function openMenu() {
      mobileNav.classList.add('is-open');
      navToggle.classList.add('is-open');
      navToggle.setAttribute('aria-expanded', 'true');
      navToggle.setAttribute('aria-label', 'Close menu');
      mobileNav.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      mobileNav.classList.remove('is-open');
      navToggle.classList.remove('is-open');
      navToggle.setAttribute('aria-expanded', 'false');
      navToggle.setAttribute('aria-label', 'Open menu');
      mobileNav.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function toggleMenu() {
      if (mobileNav.classList.contains('is-open')) closeMenu();
      else openMenu();
    }

    // Hamburger opens/closes
    navToggle.addEventListener('click', toggleMenu);

    // Close on scrim tap (outside the panel) or the X button
    mobileNav.querySelectorAll('[data-mobile-close]').forEach(function (el) {
      el.addEventListener('click', closeMenu);
    });

    // Selecting a navigation link closes the menu
    panel.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeMenu);
    });

    // Collapsible sub-menus (Products / Solutions)
    panel.querySelectorAll('.mobile-nav__group-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const group = btn.closest('.mobile-nav__group');
        const expanded = group.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    });

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
        closeMenu();
        navToggle.focus();
      }
    });
  }

  // ---------- SCROLL REVEAL ----------
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

    document.querySelectorAll('.reveal').forEach(function (el) {
      observer.observe(el);
    });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  // ---------- FAQ ACCORDION ----------
  document.querySelectorAll('.faq-item__q').forEach(function (q) {
    q.addEventListener('click', function () {
      const item = q.closest('.faq-item');
      item.classList.toggle('is-open');
    });
  });

  // ---------- PRODUCT GALLERY THUMBS ----------
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImg = document.querySelector('.product-gallery__main img');
  if (thumbs.length && mainImg) {
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        const newSrc = t.querySelector('img').src;
        mainImg.src = newSrc;
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  // ---------- HEADER SCROLL STATE ----------
  const header = document.querySelector('.site-header');
  if (header) {
    let lastY = 0;
    window.addEventListener('scroll', function () {
      const y = window.scrollY;
      if (y > 40) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
      lastY = y;
    }, { passive: true });
  }

  // ---------- SMOOTH ANCHOR ----------
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      const href = a.getAttribute('href');
      if (href.length > 1) {
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          window.scrollTo({ top: target.offsetTop - 80, behavior: 'smooth' });
        }
      }
    });
  });

})();


/* ---- B2B: add to quote (uses the cart API, checkout stays disabled) ---- */
(function () {
  document.addEventListener('click', function (e) {
    var wrap = e.target.closest('[data-b2b-qty]');
    if (wrap) {
      var input = wrap.querySelector('[data-qty-input]');
      if (e.target.closest('[data-qty-up]'))   { input.value = Math.min(9999, (parseInt(input.value,10)||1) + 1); return; }
      if (e.target.closest('[data-qty-down]')) { input.value = Math.max(parseInt(input.min,10)||1, (parseInt(input.value,10)||1) - 1); return; }
    }
    var btn = e.target.closest('[data-b2b-add]');
    if (!btn) return;

    var scope = btn.closest('[data-pcard]') || btn.closest('.pdp-info') || btn.parentNode;
    var qEl = scope ? scope.querySelector('[data-qty-input]') : null;
    var qty = qEl ? (parseInt(qEl.value, 10) || 1) : 1;
    var id  = btn.getAttribute('data-variant');
    if (!id) return;

    btn.disabled = true;
    var original = btn.textContent;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.classList.add('is-added');
        btn.textContent = 'Added';
        if (window.HadaraCart && window.HadaraCart.refresh) window.HadaraCart.refresh(true);
        setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = original; btn.disabled = false; }, 1800);
      })
      .catch(function () { btn.disabled = false; });
  });
})();


/* ---- Header account dropdown ---- */
(function () {
  function closeAll(except) {
    document.querySelectorAll('[data-acct-menu].is-open').forEach(function (m) {
      if (m === except) return;
      m.classList.remove('is-open');
      var t = m.querySelector('[data-acct-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-acct-toggle]');
    if (toggle) {
      e.preventDefault();
      var menu = toggle.closest('[data-acct-menu]');
      var open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      closeAll(menu);
      return;
    }
    if (!e.target.closest('[data-acct-panel]')) closeAll(null);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });
  /* open on hover for pointer devices, matching the mega menu */
  document.querySelectorAll('[data-acct-menu]').forEach(function (m) {
    var t;
    m.addEventListener('mouseenter', function () {
      if (!window.matchMedia('(hover: hover)').matches) return;
      clearTimeout(t);
      m.classList.add('is-open');
    });
    m.addEventListener('mouseleave', function () {
      if (!window.matchMedia('(hover: hover)').matches) return;
      t = setTimeout(function () { m.classList.remove('is-open'); }, 220);
    });
  });
})();
